import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'motion/react';

interface Props {
  /** Quando vira true, a linha encolhe a altura e desaparece (200 ms). */
  ativo: boolean;
  children: ReactNode;
}

// Linha que sai encolhendo antes da lista ser relida (cancelar, dar vaga,
// mover para suplente). Só transform/opacity + height; nada espera por ela.
export default function LinhaQueSai({ ativo, children }: Props) {
  const reduzido = useReducedMotion();

  return (
    <motion.div
      initial={false}
      animate={
        ativo && !reduzido
          ? { opacity: 0, height: 0, scale: 0.98 }
          : { opacity: 1, height: 'auto', scale: 1 }
      }
      transition={{ duration: 0.2, ease: 'easeOut' }}
      style={{ overflow: 'hidden' }}
    >
      {children}
    </motion.div>
  );
}